import { render, staticRenderFns } from "./BeButtonGroup.vue?vue&type=template&id=6e827eba&scoped=true"
import script from "./BeButtonGroup.vue?vue&type=script&lang=js"
export * from "./BeButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./BeButtonGroup.vue?vue&type=style&index=0&id=6e827eba&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e827eba",
  null
  
)

export default component.exports